// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zN_r","newExpiryDate":"styles_newExpiryDate__39Qp_","footer":"styles_footer__2YUqz"};